import { useState } from 'react';
import { X } from 'lucide-react';

const DISMISS_KEY = 'pd.desktopModeNotice.dismissed';

const dismissedBefore = () => {
  try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
};

/**
 * Shown only in the installed app when Chrome's "Desktop site" setting has
 * forced a desktop-width layout that public/index.html couldn't override
 * (it sets `data-desktop-mode` on <html>). The setting lives in Chrome, so
 * all we can do is say where to turn it off.
 */
export const DesktopModeNotice = () => {
  const [hidden, setHidden] = useState(
    () => document.documentElement.dataset.desktopMode !== 'true' || dismissedBefore(),
  );
  if (hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* private mode */ }
    setHidden(true);
  };

  return (
    <div
      className="bg-amber-wash text-amber-ink px-4 py-2.5 flex items-start justify-between gap-3 text-sm"
      role="status"
      data-testid="desktop-mode-notice"
    >
      <p className="min-w-0">
        Your phone is showing the desktop version of Precious Data. To fix it, open Chrome,
        go to Settings, then Site settings, then Desktop site, and turn it off for this
        site. Then close and reopen the app.
      </p>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        className="shrink-0 h-11 w-11 -my-2 -mr-2 inline-flex items-center justify-center rounded-md"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
